import { LineProps } from "../../../atoms/line"

export type TableTextProps = LineProps & {
  onClickRow?: () => void
}
